import * as React from 'react';
import { CloseLine } from '@mingcute/react';

import { cn } from '../lib/cn';

import { Badge, type BadgeProps } from './badge';

export interface TagProps extends BadgeProps {
  onRemove?: () => void;
  removeLabel?: string;
}

export const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  ({ className, children, onRemove, removeLabel = 'Remove', ...props }, ref) => (
    <Badge ref={ref} className={cn('pr-1', className)} {...props}>
      <span className="px-0.5">{children}</span>
      {onRemove ? (
        <button
          type="button"
          aria-label={removeLabel}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full hover:bg-black/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--color-ring)]"
        >
          <CloseLine size={12} />
        </button>
      ) : null}
    </Badge>
  ),
);
Tag.displayName = 'Tag';
